// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer","footer__title":"footer__title","footer__left":"footer__left","footer__center":"footer__center","footer__right":"footer__right","footer__phone":"footer__phone","footer__email":"footer__email","footer__copyright":"footer__copyright","footer__list":"footer__list","footer__link":"footer__link","socials__link":"socials__link","svg-icon":"svg-icon"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_footer.scss
// module id = 270
// module chunks = 0